export const KeyCodes = {
    Up: 38,
    Down: 40,
    Escape: 27,
    Enter: 13
}